<template>
  <div class="citEditor"
    :class="{on: showToolbar}"
    :data-id="id">
    <div class="citContents"
      contenteditable="true"
      v-html="contents"
      @focus="onFocus"
      @blur="onBlur"
      @mousedown="onMouseDown"
      @keydown="onKeyDown">
    </div>
    <Toolbar
      v-if="toolbar"
      :toolbar="toolbar"
      :id="id"
      :toolbarOption="toolbarOption"
      :toolbarState="toolbarState"
      :style="{top: toolbarPosition.y, left: toolbarPosition.x}" />
    <p v-if="empty" class="placeholder">text here</p>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import Toolbar from '@/components/CITEditor/Toolbar.vue'

let latestScroll = 0

function pasteDoc (body) {
  const selection = window.getSelection()
  const range = selection.getRangeAt(0)
  range.deleteContents()
  for (let i = body.children.length - 1; i >= 0; i--) {
    range.insertNode(body.children[i])
  }
}

export default {
  name: 'CITEditor',
  props: [
    'lang',
    'locale',
    'model',
    'toolbarOption'
  ],
  components: {
    Toolbar
  },
  computed: {
    contents () {
      const currentModel = this.model[this.lang]
      return currentModel
    },
    showToolbar () {
      return this.toolbar
    },
    empty () {
      return this.contents?.trim() === '' && !this.toolbar
    }
  },
  created () {
    this.id = UNIQUE.mid()
  },
  mounted () {
    const citEditor = document.querySelector('.citEditor')
    const preview = document.querySelector('#editContent .preview')
    if (preview !== null) {
      document.addEventListener('click', this.closeToolbar)
    }
    if (citEditor !== null) {
      citEditor.addEventListener('paste', this.paste)
    }
  },
  data () {
    return {
      id: null,
      toolbar: false,
      toolbarState: false,
      selection: null,
      toolbarPosition: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    paste (e) {
      const htmlStr = e.clipboardData.getData('text/html')
      /**
       * 캐스트잇 에디터 내 컨텐츠가 clipboardData에 setup된 경우
       */
      if (htmlStr !== '') {
        e.preventDefault()
        e.stopPropagation()
        const parseToHtml = function (str) {
          return new DOMParser().parseFromString(htmlStr, 'text/html')
        }
        /**
         * text노드이고 block style attribute가 있는 경우
         * paste가 inline element로 되는 문제로 인해
         * block style은 모두 리셋처리 해야함
         * 20-01-31 현재는 text-align만 해당
         */
        const innerHTML = function (str) {
          const html = parseToHtml(str)
          if (html.getElementsByTagName('body')[0].children.length === 1) {
            const children = html.getElementsByTagName('body')[0].children[0]
            children.style['text-align'] = 'inherit'
          }
          return html
        }
        const HTML = innerHTML(htmlStr).getElementsByTagName('body')[0]
        pasteDoc(HTML)
      }
    },
    closeToolbar (e) {
      e.stopPropagation()
      if (e.target.closest('.citToolbar') === null) {
        this.toolbar = false
        this.toolbarState = false
      }
    },
    moveToolbar (e) {
      if (!e) e = window.event
      if (this.toolbar) {
        const current = e.target.scrollTop
        const scroll = latestScroll - current
        if (scroll !== 0) {
          const toolbarPositionY = this.toolbarPosition.y
          const toolbarOffset = Number(toolbarPositionY.replace('px', ''))
          const calc = toolbarOffset + scroll
          this.toolbarPosition.y = `${calc}px`
          latestScroll = current
        }
      }
    },
    onMouseDown (e) {
      const preview = document.querySelector('#editContent .preview')
      if (preview !== null) {
        this.toolbarState = false
        document.addEventListener('mouseup', this.onMouseUp)
      }
    },
    /**
     * mouseup 시점의 target offset을
     * 컨텐츠박스의 client 좌표와 비교하여
     * 영역밖을 벗어나면 컨텐츠박스의 top, left 값을 position으로 가져옴
     */
    onMouseUp (e) {
      const preview = document.querySelector('#editContent .preview')
      if (preview !== null) {
        this.toolbarState = null
        preview.addEventListener('scroll', this.moveToolbar)
        latestScroll = preview.scrollTop
        document.removeEventListener('mouseup', this.onMouseUp)
      }
    },
    onFocus (e) {
      const preview = document.querySelector('#editContent .preview')
      const clientPosition = e.target.closest('.citContents').getBoundingClientRect()
      this.toolbar = true
      if (preview !== null) {
        this.toolbarPosition.y = `${Math.floor(clientPosition.top)}px`
        this.toolbarPosition.x = `${Math.floor(clientPosition.left)}px`
        preview.removeEventListener('scroll', this.moveToolbar)
      }
    },
    onBlur (e) {
      const target = e.relatedTarget
      /**
       * 에디터 툴바 중 링크 클릭시 자동으로 focus가 이동되기 때문에
       * 에디터 내에서의 포커스 이동은 onblur 조건에서 예외됨
       */
      if (target === null || target.closest('.citEditor') === null || target.closest('.citEditor').dataset.id !== this.id) {
        const html = e.target.innerHTML
        this.model[this.lang] = html
        this.toolbar = false
        this.toolbarState = false
      }
    },
    onKeyDown (e) {
      // enter
      if (e.keyCode === 13) {
        // document.execCommand('formatBlock', false, 'p')
      }
    }
  }
}
</script>
